// @ts-expect-error Could not find a declaration file for module
import StoredContentContainer from '../../containers/StoredContentContainer';
import RecommendedLessonsContainer from '../../containers/LessonsPage/RecommendedLessonsContainer';
import LessonInfoTabs from './LessonInfoTabs';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS, TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../../features/playlistContent';
import { LearningContentContainer } from '../../features/learningContent';
import { OptionalToolRecommendationSection } from '../../features/toolRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonPage = ({
  contentId,
  lesson,
  onAdvanceContent,
  onResourceClick
}) => {
  switch (contentId) {
    case TRACK_RECOMMENDATIONS_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(RecommendedLessonsContainer, {
        lesson: lesson.toObject()
      });
    case TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
        lessonId: lesson.get('id') && Number(lesson.get('id'))
      });
    case TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistIncompleteItems, {});
    case TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistComplete, {});
    case SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(OptionalToolRecommendationSection, {
          contentName: lesson.get('name'),
          lessonId: Number(lesson.get('id')),
          useCases: lesson.get('useCases')
        }), /*#__PURE__*/_jsx(LessonInfoTabs, {
          contentId: contentId,
          lesson: lesson,
          onResourceClick: onResourceClick
        })]
      });
    default:
      return /*#__PURE__*/_jsxs(LearningContentContainer, {
        contentId: Number(contentId),
        language: lesson.get('language'),
        lessonId: lesson.get('id'),
        children: [/*#__PURE__*/_jsx(StoredContentContainer, {
          contentId: contentId,
          isPubliclyVisible: lesson.get('visibility') === 'PUBLIC',
          isRequesting: lesson.get('isRequesting'),
          language: lesson.get('language'),
          lessonId: lesson.get('id'),
          lessonName: lesson.get('name'),
          onFinish: onAdvanceContent
        }), /*#__PURE__*/_jsx(LessonInfoTabs, {
          contentId: contentId,
          lesson: lesson,
          onResourceClick: onResourceClick
        })]
      });
  }
};
export default LessonPage;